import BtnInMobileNavBar from "./modules/btnInMobileNavBar";
import MobileSlider from "./modules/mobileSlider";
import SmoothScrollByQuery from "./modules/smoothScrollByQuery";

const btnInMobileNavBar = new BtnInMobileNavBar();
const customDescriptionSlider = new MobileSlider(
    '.js-description-slider',
    '.js-description-slider-slides'
);
const customWhyNeedSlider = new MobileSlider(
    '.js-why-need-slider',
    '.js-why-need-slider-slides'
);
const customAdvantagesSlider = new MobileSlider(
    '.js-advantages-slider',
    '.js-advantages-slider-slides'
);

const smoothScrollByQuery = new SmoothScrollByQuery(
    "contacts",
    ".js-scroll-contacts"
);
